export default {
  ORDERS: (state) =>
    state.orders.map((order) => ({
      start: order.date,
      end: order.date,
      id: order.id,
    })),
  ORDER: (state) => state.order,
};
